import { fetchActions } from "../reducers/active";

export default () => fetchActions.reset();
